import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Emily Lex Studio — New-customers campaign (adc_p9x2ahge9y). Lifetime
// aggregates from ANALYTICS.ADS.CAMPAIGN_PERIODS over complete months
// Nov 2023 – Aug 2026. Monthly series lives in realBrandData.ts.
//
// `monthlyBudgetDollars` is the shared $75,000 pool; the advertiser is POOLED.
export const campElsNew: FaireAdCampaignEntity = {
  token: "camp_els_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_emily_lex_studio",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 75000,
  startedRunningAt: "2023-11-08",
  segmentMetrics: {
    numCustomersAcquired: 2572,
    salesDollars: 6448929,
    totalAdsSpendDollars: 229762,
    cpaDollars: 89,
    bestEstimateSalesDollars: 4905392,
    bestEstimateRoas: 21.35,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-23T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
